<script setup lang="ts">
import { HomeButton } from '@/components/home'
import { useMemoryChallenge } from '@/composables/game/challenges'
import MemoryChallengeIcon from '@/assets/images/challenges/memory-challenge-icon.webp'

withDefaults(defineProps<{
  containerClass?: string
}>(), {
  containerClass: '',
})

const { countdown, isMemoryChallengeLive } = useMemoryChallenge()
</script>

<template>
  <HomeButton
    v-if="isMemoryChallengeLive"
    label="Memory"
    :countdown="{ value: countdown, dangerThreshold: 3600 * 3 }"
    :show-sparkle="true"
  >
    <template #blur-effect>
      <div class="absolute top-1/2 left-1/2 size-8 green-blur rounded-full -translate-y-1/2 -translate-x-1/2 z-[1]" />
    </template>
    <img
      class="size-full object-cover z-[3]"
      :src="MemoryChallengeIcon"
    >
  </HomeButton>
</template>

<style scoped>
.green-blur {
  background: #1AC080;
  filter: blur(9px);
}
</style>
